import type { CogniSummary, CogniSummaryCite } from '../types';

export function citeLabel(c: CogniSummaryCite): string {
  return `${c.drug_name} ${c.section_number ?? c.section_title}`.trim();
}

/** Distinct cited drugs (by drug_id), in first-citation order. */
export function quotedExamples(s: CogniSummary): CogniSummaryCite[] {
  const seen = new Set<number>();
  const out: CogniSummaryCite[] = [];
  for (const p of s.patterns) {
    for (const c of p.cites) {
      if (!seen.has(c.drug_id)) {
        seen.add(c.drug_id);
        out.push(c);
      }
    }
  }
  return out;
}

export function escapeHtml(t: string): string {
  return t
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function summaryShareHtml(s: CogniSummary): string {
  const items = s.patterns
    .map((p) => `<li>${escapeHtml(p.text)} (${p.cites.map((c) => escapeHtml(citeLabel(c))).join('; ')})</li>`)
    .join('');
  return `<p><strong>${escapeHtml(s.title)}</strong></p><ul>${items}</ul>`;
}

export function summaryErrorCopy(status: number | undefined): { message: string; retry: boolean } {
  switch (status) {
    case 404:
      return { message: 'Summary unavailable. Run the search again.', retry: false };
    case 403:
      return { message: "You don't have access to summarise these results.", retry: false };
    case 422:
      return { message: 'No label passages to summarise for these results.', retry: false };
    default:
      return { message: "Couldn't generate a summary.", retry: true };
  }
}

export function httpStatus(err: unknown): number | undefined {
  const status = (err as { response?: { status?: unknown } } | null)?.response?.status;
  return typeof status === 'number' ? status : undefined;
}
